<template>
  <q-pull-to-refresh @refresh="setWayBillList">
    <WayBillList :filter="filter" :items="items" title="لیست بارنامه های صادر شده تا کنون" :show-all="true" :available-items="[]"/>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from "vuex";
import WayBillList from "@/components/WayBill/WayBillList";

export default {
  name: "AllWayBillList",
  components: {WayBillList},
  data(){
    return{
      items:[],
      filter: ''
    }
  },
  methods:{
    ...mapActions({
      getWayBillList: 'Orders/getWayBillList'
    }),
    setWayBillList(){
      this.getWayBillList().then((res)=>{
        this.items = res;
        this.items.forEach((record) => {
          record.Sale_Nums = eval(record.Sale_Nums)
        })
      })
    }
  },
  created() {
    this.setWayBillList();
  }
}
</script>

<style scoped>

</style>